export enum SportsEnum {
  Cycling = 'cycling',
  Running = 'running',
  Rowing = 'rowing',
}

export interface Sport {
  name: SportsEnum;
  label: string;
}
